import { ToggleButton } from '@common/components/forms';
import { IHospitalOrganizationListingModel } from '@common/models/HospitalOrganizationListingModel';
import { observer } from 'mobx-react';
import React from 'react';
import { Table } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { UserLocationsAddStore } from './UserLocationsAddStore';

const UserLocationsAddTableHeader = observer(() => (
    <tr key={"header"} className="">
        <th className="w-25">Name</th>
        <th className="w-auto">Description</th>
        <th className="action text-end">Action</th>
    </tr>));

const UserLocationsAddTableRows = observer(({ userLocationsAddStore }: { userLocationsAddStore: UserLocationsAddStore }) => {
    if (userLocationsAddStore.isLoading) {
        const rows = Array.from({ length: userLocationsAddStore.hospitalOrgSearchStore.searchParams.top }, (_, i) =>
            <tr key={i}>
                {Array.from({ length: 3 }, (_, j) =>
                    <td key={j}><Skeleton count={1} /></td>)}
            </tr>)
        return (
            <>
                {rows}
            </>
        )
    } else {
        const rows = userLocationsAddStore.hospitalOrgSearchStore.searchResults.results.map((o: IHospitalOrganizationListingModel) => {
            let isSelected = userLocationsAddStore.isSelectedOrganization(o);
            return (
                <tr key={o.organizationId} className={"border-default cursor-pointer"} onClick={() => isSelected ? userLocationsAddStore.removeSelectedOrganization(o) : userLocationsAddStore.addSelectedOrganization(o)}>
                    <td>{o.name + (o.hospitalCount > 1 ? ' - (' + o.hospitalCount + ')' : '')}</td>
                    <td>{o.description}</td>
                    <td className="action text-end">
                        <ToggleButton className="d-inline-block" defaultChecked={isSelected}>
                        </ToggleButton>
                    </td>
                </tr>
            )
        });
        return (
            <>
                {rows}
            </>
        )
    }
});

export const UserLocationsAddTable = observer(({ userLocationsAddStore }: { userLocationsAddStore: UserLocationsAddStore }) => {
    return (
        <Table className="body table table-hover">
            <thead>
                <UserLocationsAddTableHeader />
            </thead>
            <tbody>
                {
                    (userLocationsAddStore.isLoading || userLocationsAddStore.hospitalOrgSearchStore.searchResults.totalRecordCount > 0) &&
                    <UserLocationsAddTableRows userLocationsAddStore={userLocationsAddStore} />
                }
                {
                    !userLocationsAddStore.isLoading && userLocationsAddStore.hospitalOrgSearchStore.searchResults.totalRecordCount === 0 &&
                    (
                        <tr>
                            <td colSpan={3} className="text-center">
                                <div className="h1 align-self-center">No hospitals match your search criteria or they are already assigned to {userLocationsAddStore.userStore.user.firstName + ' ' + userLocationsAddStore.userStore.user.lastName}</div>
                            </td>
                        </tr>
                    )
                }
            </tbody>
        </Table>)
});
